import { addParameterToURL } from "@/shared/ui";
import type { PersonalLoanRequest, PersonalLoanResponseItem } from "../types";

export function convertKhData(
	request: PersonalLoanRequest,
	response: PersonalLoanResponseItem,
): PersonalLoanResponseItem {
	const productData = { ...response };

	if (productData.marketing?.newTargetUrl && request.incomeList.length > 0) {
		productData.marketing.newTargetUrl = addParameterToURL(productData.marketing.newTargetUrl, {
			p_p_id: "contactform_WAR_contactformportlet",
			_contactform_WAR_contactformportlet_amount: request.loanAmount,
			_contactform_WAR_contactformportlet_maturity: request.maturityYears * 12,
			_contactform_WAR_contactformportlet_installment: response.startInstallment,
			_contactform_WAR_contactformportlet_thm: response.apr * 100,
		});
	}

	return productData;
}
